var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390,
    height: 1033.195,
    viewBox: "0 0 390 1033.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_27",
    x: 0,
    y: 188.822,
    width: 210,
    height: 210,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_28",
    x: 123,
    y: 395.822,
    width: 210,
    height: 210,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_29",
    x: 9,
    y: 610.822,
    width: 210,
    height: 210,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_30",
    x: 180,
    y: 780.822,
    width: 210,
    height: 210,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(8 -2091.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M-166.049,2370.847s208.646,286.071,289.7,286.071,123.537-137.541,213.783-136.875,116.056,136.014,209.313,136.875S651.937,2533.607,697.064,2476.9s169.612-106.052,169.612-106.052",
    transform: "translate(2748.101 2257.55) rotate(90)",
    fill: "none",
    stroke: "#5cbe8e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, 2091.18)",
    filter: "url(#Ellipse_27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27-2",
    "data-name": "Ellipse 27",
    cx: 57,
    cy: 57,
    r: 57,
    transform: "translate(48 236.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, 2091.18)",
    filter: "url(#Ellipse_28)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28-2",
    "data-name": "Ellipse 28",
    cx: 57,
    cy: 57,
    r: 57,
    transform: "translate(171 443.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, 2091.18)",
    filter: "url(#Ellipse_29)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29-2",
    "data-name": "Ellipse 29",
    cx: 57,
    cy: 57,
    r: 57,
    transform: "translate(57 658.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8, 2091.18)",
    filter: "url(#Ellipse_30)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30-2",
    "data-name": "Ellipse 30",
    cx: 57,
    cy: 57,
    r: 57,
    transform: "translate(228 828.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parcel",
    transform: "translate(59.09 2360.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M63.2,2.6H18.095a3.938,3.938,0,0,0-3.934,3.934v6.275L2.238.884A1.311,1.311,0,0,0,.384,2.738L15.829,18.183l-8.16,8.16-5.43-5.43A1.311,1.311,0,0,0,.384,22.768l10.9,10.9,0,1.18a13.542,13.542,0,0,0,2.879,8.327v8.463a3.938,3.938,0,0,0,3.934,3.934H63.2a3.938,3.938,0,0,0,3.934-3.934V21.74a1.311,1.311,0,0,0-2.622,0v29.9A1.313,1.313,0,0,1,63.2,52.949H35.827c.055-.049.109-.1.161-.152a3.76,3.76,0,0,0,.778-1.13,3.787,3.787,0,0,0,5.08-5.078,3.787,3.787,0,0,0,1.129-6.134l-4.516-4.516a4.172,4.172,0,0,0,3.673-1.694l.043-.059a4.258,4.258,0,0,0-.885-5.916c-1.174-.873-2.765-2.06-4.729-3.53a16.133,16.133,0,0,0-9.6-3.194h-.017l-4.037,0-6.121-6.121v-8.9A1.312,1.312,0,0,1,18.095,5.22H31.784V18.592a1.312,1.312,0,0,0,2.238.928l2.849-2.849,2.849,2.849a1.311,1.311,0,0,0,1.854,0l2.849-2.849,2.849,2.849a1.312,1.312,0,0,0,2.239-.927V5.22H63.2a1.312,1.312,0,0,1,1.311,1.311v4.719a1.311,1.311,0,0,0,2.622,0V6.532A3.938,3.938,0,0,0,63.2,2.6ZM16.784,51.638v-5.7l4.285,4.285h0L23.8,52.949h-5.7A1.313,1.313,0,0,1,16.784,51.638Zm10.161-27.47h.014a13.493,13.493,0,0,1,8.032,2.672c1.966,1.471,3.559,2.66,4.736,3.534a1.628,1.628,0,0,1,.333,2.263l-.043.059a1.547,1.547,0,0,1-2.085.386L32.9,29.839A1.52,1.52,0,0,0,31,32.191L41.121,42.31a1.163,1.163,0,0,1-1.543,1.736L34.5,38.968a1.3,1.3,0,0,0-.11-.1l-.519-.519a1.311,1.311,0,0,0-1.855,1.854l5.6,5.6c.058.058.118.113.179.167l1.48,1.48A1.163,1.163,0,1,1,37.635,49.1l-1.48-1.48c-.053-.06-.108-.12-.166-.179l-4.982-4.982a1.4,1.4,0,0,0-.11-.1l-.519-.519A1.311,1.311,0,1,0,28.523,43.7l5.7,5.7a1.163,1.163,0,0,1-1.736,1.543l-1.655-1.655c-.054-.061-.109-.121-.167-.179l-3.153-3.154a1.4,1.4,0,0,0-.11-.1l-.519-.519a1.311,1.311,0,0,0-1.854,1.855L28.9,51.066a1.163,1.163,0,0,1-1.736,1.543L20.3,45.74v0l-3.224-3.224A10.891,10.891,0,0,1,13.9,34.852l0-1.906,8.773-8.773ZM12.235,30.91,9.523,28.2l8.16-8.161L20.4,22.749ZM46.89,15.426l-1.538-1.538a1.312,1.312,0,0,0-1.854,0l-2.849,2.849L37.8,13.888a1.311,1.311,0,0,0-1.854,0l-1.538,1.538V5.22H46.89Zm0,0",
    transform: "translate(0 -0.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M383.7,299.656h-8.392a1.311,1.311,0,1,0,0,2.622H383.7a1.311,1.311,0,0,0,0-2.622Zm0,0",
    transform: "translate(-324.96 -260.43)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M401.661,340.9h-5.682a1.311,1.311,0,1,0,0,2.622h5.682a1.311,1.311,0,0,0,0-2.622Zm0,0",
    transform: "translate(-342.918 -296.268)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M355.979,340.9a1.312,1.312,0,1,0,.927.384A1.319,1.319,0,0,0,355.979,340.9Zm0,0",
    transform: "translate(-308.163 -296.265)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M493.311,112.488a1.312,1.312,0,1,0,.927.384A1.322,1.322,0,0,0,493.311,112.488Zm0,0",
    transform: "translate(-427.488 -97.804)",
    fill: "#58a596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(187.5 2559.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M448,448h2.167v2.167H448Z",
    transform: "translate(-389.5 -389.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M304,448h2.167v2.167H304Z",
    transform: "translate(-265 -389.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M448,320h2.167v2.167H448Z",
    transform: "translate(-389.5 -278.833)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M232.083,96h-19.5a1.083,1.083,0,0,0-1.083,1.083v33.583H193.083A1.083,1.083,0,0,0,192,131.75v17.333a1.083,1.083,0,0,0,1.083,1.083h39a1.083,1.083,0,0,0,1.083-1.083v-52A1.083,1.083,0,0,0,232.083,96Zm-11.917,36.833H224.5v4.333h-4.333Zm-6.5-2.167V115.5H218v5.417A1.083,1.083,0,0,0,219.083,122h6.5a1.083,1.083,0,0,0,1.083-1.083V115.5H231v15.167Zm6.5-15.167H224.5v4.333h-4.333Zm0-17.333H224.5V102.5h-4.333Zm-6.5,0H218v5.417a1.083,1.083,0,0,0,1.083,1.083h6.5a1.083,1.083,0,0,0,1.083-1.083V98.167H231v15.167H213.667Zm-13,34.667H205v4.333h-4.333Zm-6.5,0H198.5v5.417a1.083,1.083,0,0,0,1.083,1.083h6.5a1.083,1.083,0,0,0,1.083-1.083v-5.417H211.5V148H194.167ZM231,148H213.667V132.833H218v5.417a1.083,1.083,0,0,0,1.083,1.083h6.5a1.083,1.083,0,0,0,1.083-1.083v-5.417H231Z",
    transform: "translate(-168.167 -85.167)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M448,192h2.167v2.167H448Z",
    transform: "translate(-389.5 -168.167)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M18.167,22.5h3.25v4.333a3.25,3.25,0,1,0,6.5,0V24.667H25.75v2.167a1.083,1.083,0,1,1-2.167,0v-6.5a2.167,2.167,0,1,1,4.333,0H25.75V22.5H47.417V29A1.083,1.083,0,0,0,48.5,30.083H55v29.25h2.167V29a1.083,1.083,0,0,0-.317-.766l-7.583-7.583a1.083,1.083,0,0,0-.766-.317H30.083a4.333,4.333,0,0,0-8.667,0H17.083A1.083,1.083,0,0,0,16,21.417V75.583a1.083,1.083,0,0,0,1.083,1.083H37.667V74.5h-19.5Zm31.417,1.532,3.885,3.885H49.583Z",
    transform: "translate(-16 -16)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M72,256h2.167v2.167H72Z",
    transform: "translate(-64.417 -223.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M104,256h23.833v2.167H104Z",
    transform: "translate(-92.083 -223.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M56,288H86.333v2.167H56Z",
    transform: "translate(-50.583 -251.167)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M56,320H86.333v2.167H56Z",
    transform: "translate(-50.583 -278.833)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M56,352H71.167v2.167H56Z",
    transform: "translate(-50.583 -306.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M56,384H66.833v2.167H56Z",
    transform: "translate(-50.583 -334.167)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M144,128.667v.158a3.1,3.1,0,0,0,2.167,2.95V133h2.167v-1.225a3.092,3.092,0,0,0,.457-5.716L146.678,125a.925.925,0,0,1,.414-1.753h.316a.926.926,0,0,1,.925.925v.158H150.5v-.158a3.1,3.1,0,0,0-2.167-2.95V120h-2.167v1.225a3.092,3.092,0,0,0-.457,5.716L147.822,128a.925.925,0,0,1-.414,1.753h-.316a.926.926,0,0,1-.925-.925v-.158Z",
    transform: "translate(-126.667 -105.917)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M112,160h2.167v2.167H112Z",
    transform: "translate(-99 -140.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M208,160h2.167v2.167H208Z",
    transform: "translate(-182 -140.5)",
    fill: "#58a596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(79.146 2777.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M48.625,39.776h0c-1.679,0-2.626-.872-3.169-2.911a37.516,37.516,0,0,1-.593-8.311,53.785,53.785,0,0,0-1.015-12.208.867.867,0,0,0-1.684.413,52.48,52.48,0,0,1,.965,11.806,38.425,38.425,0,0,0,.651,8.746,6.965,6.965,0,0,0,1.14,2.466H8.791a6.966,6.966,0,0,0,1.14-2.466,38.4,38.4,0,0,0,.651-8.746c.031-5.062.066-10.8,2.137-15.189,2.331-4.942,6.955-7.345,14.136-7.345a18.474,18.474,0,0,1,9.591,2.2,11.636,11.636,0,0,1,4.711,5.507.867.867,0,0,0,1.588-.7,13.5,13.5,0,0,0-5.4-6.294A16.453,16.453,0,0,0,32,4.766a5.163,5.163,0,0,0-10.3,0A16.609,16.609,0,0,0,16.58,6.624a13.369,13.369,0,0,0-5.43,6.013c-2.234,4.736-2.27,10.677-2.3,15.918a37.489,37.489,0,0,1-.593,8.311c-.542,2.039-1.49,2.91-3.169,2.911h0a5.083,5.083,0,0,0,0,10.166H10.57a.867.867,0,1,0,0-1.734H5.083a3.349,3.349,0,0,1,0-6.7H48.626a3.349,3.349,0,0,1,0,6.7H14.038a.867.867,0,0,0,0,1.734H17.6a9.3,9.3,0,0,0,18.514,0H48.625a5.083,5.083,0,0,0,0-10.166ZM26.854,1.734a3.437,3.437,0,0,1,3.364,2.755,29.738,29.738,0,0,0-6.727,0A3.436,3.436,0,0,1,26.854,1.734Zm0,54.907a7.575,7.575,0,0,1-7.514-6.7H34.368A7.575,7.575,0,0,1,26.854,56.641Zm0,0",
    transform: "translate(0)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M354.187,35.1a11.246,11.246,0,0,1,3.078,2.936,16.672,16.672,0,0,1,3.065,10.177.867.867,0,0,0,1.734,0A18.4,18.4,0,0,0,358.6,36.92a12.672,12.672,0,0,0-3.568-3.337.867.867,0,0,0-.841,1.516Zm0,0",
    transform: "translate(-313.412 -29.659)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M411.934,38.113c.139.091,3.417,2.291,3.417,7.825a.867.867,0,0,0,1.734,0c0-6.527-4.043-9.176-4.216-9.285a.867.867,0,0,0-.935,1.46Zm0,0",
    transform: "translate(-364.618 -32.354)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M45.214,49.079a.867.867,0,0,0,.867-.867,16.675,16.675,0,0,1,3.065-10.177A11.283,11.283,0,0,1,52.224,35.1a.867.867,0,0,0-.841-1.516,12.672,12.672,0,0,0-3.568,3.337,18.4,18.4,0,0,0-3.468,11.292A.867.867,0,0,0,45.214,49.079Zm0,0",
    transform: "translate(-39.291 -29.658)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M11.758,46.8a.867.867,0,0,0,.867-.867c0-5.53,3.273-7.731,3.417-7.825a.867.867,0,0,0-.935-1.46c-.172.11-4.216,2.758-4.216,9.285A.867.867,0,0,0,11.758,46.8Zm0,0",
    transform: "translate(-9.649 -32.354)",
    fill: "#58a596"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_stroke_cut_Ex",
    "data-name": "Line stroke cut Ex",
    transform: "translate(216.19 2925.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(32 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M216,128h2.058v2.058H216Z",
    transform: "translate(-192.335 -113.595)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M280,128h2.058v2.058H280Z",
    transform: "translate(-248.103 -113.595)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M235.087,182.572A2.834,2.834,0,0,0,238.174,180h-2.058c0,.181-.391.514-1.029.514s-1.029-.333-1.029-.514H232A2.834,2.834,0,0,0,235.087,182.572Z",
    transform: "translate(-206.277 -158.907)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M87.058,60.343l-3.913-3.913L81.69,57.885,85.6,61.8a6.645,6.645,0,0,1,1.959,4.729v6.321a2.833,2.833,0,0,1-2.83,2.83H82.417V70.533h2.058V68.475H80.359V49.955a1.029,1.029,0,0,0-1.029-1.029h-5.58l-5.869-3.735-.852-3.407.36-.183a4.864,4.864,0,0,0,2.68-4.36v-.663h.514a3.605,3.605,0,0,0,3.6-3.6V31.948a3.605,3.605,0,0,0-3.523-3.6,3.6,3.6,0,0,0,.437-1.72V23.46A7.468,7.468,0,0,0,63.639,16H57.98a7.468,7.468,0,0,0-7.46,7.46v3.168a3.6,3.6,0,0,0,.437,1.72,3.605,3.605,0,0,0-3.524,3.6v1.029a3.605,3.605,0,0,0,3.6,3.6h.514v.7a4.861,4.861,0,0,0,2.7,4.371l.33.165-.844,3.374-5.869,3.735h-5.58a1.029,1.029,0,0,0-1.029,1.029v3.689l-3.814,3.814L38.9,58.914l2.359-2.359V68.475H37.144v2.058H39.2v5.145H36.887a2.833,2.833,0,0,1-2.83-2.83V66.527A6.645,6.645,0,0,1,36.016,61.8l.827-.826-1.455-1.455-.827.827A8.688,8.688,0,0,0,32,66.527v6.321a4.893,4.893,0,0,0,4.887,4.887H84.732a4.893,4.893,0,0,0,4.887-4.887V66.527a8.689,8.689,0,0,0-2.562-6.184ZM57.723,50.984H63.9v7.2H57.723Zm7.629-2.058,1.776-1.775,2.79,1.775ZM53.393,27.988a1.521,1.521,0,0,1-.815-1.361v-.762l3.734-2.075a9.206,9.206,0,0,1,8.995,0l3.734,2.075v.762a1.543,1.543,0,0,1-2.4,1.284l-2.407-1.6a6.157,6.157,0,0,0-6.849,0l-2.407,1.6A1.521,1.521,0,0,1,53.393,27.988Zm18.734,3.96v1.029a1.545,1.545,0,0,1-1.543,1.543H70.07V30.4h.514A1.545,1.545,0,0,1,72.128,31.948ZM57.98,18.058h5.659a5.408,5.408,0,0,1,5.4,5.4v.051l-2.735-1.519a11.251,11.251,0,0,0-10.993,0l-2.735,1.519V23.46A5.408,5.408,0,0,1,57.98,18.058ZM51.035,34.521a1.545,1.545,0,0,1-1.543-1.543V31.948A1.545,1.545,0,0,1,51.035,30.4h.514v4.116Zm2.572,2.76V30.192a3.593,3.593,0,0,0,2.512-.569l2.407-1.6a4.105,4.105,0,0,1,4.566,0L65.5,29.624a3.6,3.6,0,0,0,2.512.568v7.049a2.816,2.816,0,0,1-1.551,2.524L61.5,42.278a1.55,1.55,0,0,1-1.388,0l-4.941-2.47a2.814,2.814,0,0,1-1.564-2.531Zm5.585,6.842a3.617,3.617,0,0,0,3.238-.008l2.718-1.376.7,2.785-3.4,3.4H59.178l-3.4-3.4.691-2.763Zm-4.7,3.028,1.776,1.775H51.7ZM43.318,50.984H55.665v8.231a1.029,1.029,0,0,0,1.029,1.029h8.231a1.029,1.029,0,0,0,1.029-1.029V50.984H78.3V68.475H77.273a8.244,8.244,0,0,0-8.167,7.2H65.954V70.533A1.029,1.029,0,0,0,64.925,69.5H56.694a1.029,1.029,0,0,0-1.029,1.029v5.145H52.514a8.244,8.244,0,0,0-8.167-7.2H43.318ZM41.26,75.678V70.533h3.087a6.184,6.184,0,0,1,6.088,5.145Zm16.463,0V71.562H63.9v4.116Zm22.636,0H71.185a6.184,6.184,0,0,1,6.088-5.145h3.087Z",
    transform: "translate(-32 -16)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M136,304h2.058v2.058H136Z",
    transform: "translate(-122.624 -266.959)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M168,304h4.116v2.058H168Z",
    transform: "translate(-150.508 -266.959)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M136,336h8.231v2.058H136Z",
    transform: "translate(-122.624 -294.843)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M313.029,311.2h3.6a3.605,3.605,0,0,0,3.6-3.6v-2.572A1.029,1.029,0,0,0,319.2,304h-3.6a3.605,3.605,0,0,0-3.6,3.6v2.572A1.029,1.029,0,0,0,313.029,311.2Zm1.029-3.6a1.545,1.545,0,0,1,1.543-1.543h2.572V307.6a1.545,1.545,0,0,1-1.543,1.543h-2.572Z",
    transform: "translate(-275.988 -266.959)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Je_re\\xE7ois_l_ordonnance",
    "data-name": "Je re\\xE7ois l\\u2019ordonnance",
    transform: "translate(169 2378)",
    fill: "#273e4f",
    fontSize: 18,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Je re\xE7ois"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "l\u2019ordonnance"))), /*#__PURE__*/React.createElement("text", {
    id: "Mon_patient_est_inform\\xE9",
    "data-name": "Mon patient  est inform\\xE9",
    transform: "translate(177 2799)",
    fill: "#273e4f",
    fontSize: 18,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mon patient "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "est inform\xE9"))), /*#__PURE__*/React.createElement("text", {
    id: "Il_vient_r\\xE9cup\\xE9rer_sa_commande",
    "data-name": "Il vient r\\xE9cup\\xE9rer  sa commande",
    transform: "translate(54 2976)",
    fill: "#273e4f",
    fontSize: 18,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Il vient r\xE9cup\xE9rer "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "sa commande"))), /*#__PURE__*/React.createElement("text", {
    id: "Je_la_pr\\xE9pare",
    "data-name": "Je la  pr\\xE9pare",
    transform: "translate(59 2592)",
    fill: "#273e4f",
    fontSize: 18,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Je la "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "pr\xE9pare"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLine);
export default __webpack_public_path__ + "static/media/mobile-line.dc4dd27f1fb4bd6601bee1c619e8f6e8.svg";
export { ForwardRef as ReactComponent };